import script from "./BlockAcademies.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockAcademies.vue?vue&type=script&setup=true&lang=js"

import "./BlockAcademies.vue?vue&type=style&index=0&id=1a326189&lang=scss"

const __exports__ = script;

export default __exports__